import { z } from "zod";

export const KPIs = z.object({
  fleetTotal: z.number().int(),
  active: z.number().int(),
  inactive: z.number().int(),
  inactiveByState: z.record(z.string(), z.number().int()),
  recoveredOperability: z.number().int(),
  requestsHandled: z.number().int(),
});
export type KPIs = z.infer<typeof KPIs>;

export const ExecutorKPIs = z.object({
  executorId: z.string().uuid(),
  name: z.string(),
  kpis: KPIs,
});
export type ExecutorKPIs = z.infer<typeof ExecutorKPIs>;

export const LocationKPIs = z.object({
  locationId: z.string().uuid(),
  locationName: z.string(),
  kpis: KPIs,
  byExecutor: z.array(ExecutorKPIs),
});
export type LocationKPIs = z.infer<typeof LocationKPIs>;

export const KpisResponse = z.object({
  summary: KPIs.extend({ byExecutor: z.array(ExecutorKPIs) }),
  byLocation: z.array(LocationKPIs),
});
export type KpisResponse = z.infer<typeof KpisResponse>;

export const KpisSummaryItem = z.object({
  customerId: z.string().uuid(),
  customerName: z.string(),
  kpis: KPIs,
});
export type KpisSummaryItem = z.infer<typeof KpisSummaryItem>;

export const KpisSummaryResponse = z.array(KpisSummaryItem);
export type KpisSummaryResponse = z.infer<typeof KpisSummaryResponse>;
